import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PageSharedModule } from '../shared/page-shared.module';
import { DynamicRenderSharedModule } from '../../shared/shared.module';
import { PageResolverModule } from '../resolver/page-resolver.module';
import { StandardPageComponent } from './standard-page/standard-page.component';
import { StandardReviewPageComponent } from './standard-review-page/standard-review-page.component';
import { PageReviewModule } from '../review/page-review.module';
import { SharedModule } from '@shared/shared.module';

const components = [StandardPageComponent, StandardReviewPageComponent];

@NgModule({
  declarations: [...components],
  exports: [...components],
  imports: [CommonModule, PageSharedModule, PageResolverModule, DynamicRenderSharedModule, PageReviewModule, SharedModule]
})
export class CoreCustomPagesModule {}
